import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  emoji: '🤸',
  title: 'TOMO 1 — GIMNASIA ARTÍSTICA EN SUELO RESUELTA',
  desc: '60 clases listas con progresiones, elementos, cuentas y correcciones para el aparato más completo'
}, {
  emoji: '⚖️',
  title: 'TOMO 2 — BARRA DE EQUILIBRIO RESUELTA',
  desc: 'Sesiones completas desde el equilibrio básico hasta series de competencia con protocolo de spotting'
}, {
  emoji: '🏃',
  title: 'TOMO 3 — SALTO Y POTRO RESUELTO',
  desc: 'Análisis de las 5 fases del salto aplicado a 60 clases progresivas con seguridad garantizada'
}, {
  emoji: '🔄',
  title: 'TOMO 4 — BARRAS ASIMÉTRICAS RESUELTAS',
  desc: 'El aparato más técnico completamente dominado: enlaces, transferencias, salidas y elementos de vuelo'
}, {
  emoji: '🌟',
  title: 'TOMO 5 — ACROBACIAS Y ELEMENTOS LIBRES RESUELTOS',
  desc: 'Volteretas, ruedas, pinos, mortales y combinaciones progresivas para todos los niveles'
}, {
  emoji: '📋',
  title: 'TOMO 6 — PLANIFICACIÓN ANUAL Y GESTIÓN RESUELTA',
  desc: 'Organizá todo tu año de trabajo en un solo tomo: periodización, evaluación y gestión profesional'
}];
const includes = ['Planificación lista para usar desde el primer día', 'Clases con objetivo, desarrollo y cierre completo', 'Protocolo de spotting detallado por elemento', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio', 'Checklist de seguridad pre y durante la clase', 'Planillas de seguimiento del alumno', 'Adaptaciones para grupos heterogéneos', 'Correcciones técnicas de los errores más frecuentes', '100% adaptado a la realidad del profesor de artística argentino'];
export function TomosSection() {
  return <Section id="tomos" data-id="element-294">
      <div className="text-center mb-6 md:mb-16" data-id="element-295">
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-296">
          LOS 6 TOMOS
        </h2>
        <p className="text-sm md:text-xl text-gray-400" data-id="element-297">
          Para profesores de gimnasia artística de todos los niveles y enfoques
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-6 mb-8 md:mb-16" data-id="element-298">
        {tomos.map((tomo, i) => <div key={i} className="bg-navy-800 border border-navy-700 rounded-xl md:rounded-2xl p-3 md:p-8 hover:border-gold-500/50 transition-colors group" data-id="element-299">
            <div className="text-2xl md:text-4xl mb-3 md:mb-6 bg-navy-900 w-10 h-10 md:w-16 md:h-16 rounded-lg md:rounded-xl flex items-center justify-center border border-navy-700 group-hover:scale-110 transition-transform" data-id="element-300">
              {tomo.emoji}
            </div>
            <h3 className="text-xs sm:text-sm md:text-xl font-bold text-white mb-1.5 md:mb-4 leading-snug" data-id="element-301">
              {tomo.title}
            </h3>
            <p className="text-gray-400 leading-snug text-xs md:text-base md:leading-relaxed" data-id="element-302">
              "{tomo.desc}"
            </p>
          </div>)}
      </div>

      <div className="bg-navy-900 border border-navy-700 rounded-2xl md:rounded-3xl p-4 md:p-12 max-w-4xl mx-auto relative overflow-hidden" data-id="element-303">
        <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-304" />

        <h3 className="text-lg md:text-2xl font-bold text-white mb-4 md:mb-8 text-center" data-id="element-305">
          Cada tomo incluye:
        </h3>

        <div className="grid md:grid-cols-2 gap-x-8 gap-y-2 md:gap-y-4" data-id="element-306">
          {includes.map((item, i) => <div key={i} className="flex items-start space-x-2 md:space-x-3" data-id="element-307">
              <CheckCircle2 className="w-4 h-4 md:w-6 md:h-6 text-gold-400 flex-shrink-0 mt-0.5" data-id="element-308" />
              <span className="text-gray-300 text-sm md:text-base" data-id="element-309">{item}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}